import * as API from "../api";
import AppState from '../state/AppState';

export const getCollaborators = () => {
  return API.getCollaborators(AppState.state.selectedOrg.id)
    .then((result) => {
      AppState.setCollaborators(result.collaborators.items);
      return API.getAllInvites(AppState.state.selectedOrg.id);
    })
    .then((result) => {
      AppState.setInvites(result.invites.items);
    })
};

export const patchOrg = (patch) => {
  return API.patchOrg(AppState.state.selectedOrg.id, patch)
    .then((result) => {
      AppState.selectOrg(result.org);
    })
};


export const getOrgSubscription = () => {
  return API.getOrgSubscription(AppState.state.selectedOrg.id)
    .then((result) => {
      AppState.setOrgSubscription(result.subscription);
    });
};

export const cancelOrgSubscription = () => {
  return API.cancelOrgSubscription(AppState.state.selectedOrg.id, AppState.state.orgSubscription.id)
    .then(() => getOrgSubscription())

};

export const renewOrgSubscription = () => {
  return API.renewOrgSubscription(AppState.state.selectedOrg.id, AppState.state.orgSubscription.id)
    .then(() => getOrgSubscription())
};

export const getOrgPaymentMethod = () => {
  return API.getOrgPaymentMethod(AppState.state.selectedOrg.id)
    .then((result) => AppState.setOrgPaymentMethod(result.source))
};

export const updateOrgPaymentMethod = (token) => {
  return API.updateOrgPaymentMethod(AppState.state.selectedOrg.id, token)
    .then((result) => getOrgPaymentMethod())
};

export const getOrgCharges = () => {
  return API.getOrgCharges(AppState.state.selectedOrg.id)
    .then((result) => {
      AppState.setOrgCharges(result.charges);
    });
};

export const getOrgNextInvoice = () => {
  return API.getOrgNextInvoice(AppState.state.selectedOrg.id)
    .then((result) => {
      AppState.setOrgNextInvoice(result.invoice);
    });
};



// WEBPACK FOOTER //
// ./src/actions/OrgActions.js